import { Yup } from 'app/components/core/Form';

const SnowflakeAccountNameRegex = /^(https?:\/\/|)([\w\-.](\/)?)*$/;
const DatameerUrlRegex = /^(?!(.*datameer\.cloud.*))/;
export const SnowflakeAccountSchema = Yup.string()
    .required('forms:common.fields.account.required')
    .trim()
    .matches(SnowflakeAccountNameRegex, 'forms:common.fields.account.invalid')
    .matches(DatameerUrlRegex, 'forms:common.fields.account.datameerUrl');

export const CredentialsSchema = Yup.object({
    privateKey: Yup.string().required('forms:common.fields.privateKey.required'),
    keyPassword: Yup.string().nullable()
});

export const ServiceAccountConnectionSchema = Yup.object({
    account: SnowflakeAccountSchema,
    user: Yup.string().required('forms:common.fields.serviceAccountUser.required')
}).concat(CredentialsSchema);
